/* eslint-disable max-lines */
/**
 * Localized Error Codes
 * The error messages here are designed to be user-friendly.
 * So you would find many error codes are mapped to the same
 * message as the system details are considered to be user-irrelevant.
 * For debugging purpose, please refer to Core-API's error code
 * dictionary.
*/
export default {
  'ERROR_CODE_-1': {
    en: 'Unknown error',
    zh: ''
  },
  ERROR_CODE_1: {
    en: 'Invalid login params',
    zh: ''
  },
  ERROR_CODE_2: {
    en: 'Error on /login',
    zh: ''
  },
  ERROR_CODE_3: {
    en: 'Incorrect credentials',
    zh: ''
  },
  ERROR_CODE_4: {
    en: 'Validation error',
    zh: ''
  },
  ERROR_CODE_5: {
    en: 'Error on /register',
    zh: ''
  },
  ERROR_CODE_6: {
    en: 'Email address already exists',
    zh: ''
  },
  ERROR_CODE_7: {
    en: 'Phone number already exists',
    zh: ''
  },
  ERROR_CODE_8: {
    en: 'Phone number is not a valid number',
    zh: ''
  },
  ERROR_CODE_9: {
    en: 'Error on FFID /register',
    zh: ''
  },
  ERROR_CODE_10: {
    en: 'Invalid fetch-profile params',
    zh: ''
  },
  ERROR_CODE_11: {
    en: 'Error on FFID /account',
    zh: ''
  },
  ERROR_CODE_12: {
    en: 'Invalid subscribe params',
    zh: ''
  },
  ERROR_CODE_15: {
    en: 'Email does not exist',
    zh: ''
  },
  ERROR_CODE_16: {
    en: 'There was a problem sending the reset password email. Please contact us: product@ff.com.',
    zh: ''
  },
  ERROR_CODE_17: {
    en: 'There was a problem resetting the password. Please try again later.',
    zh: ''
  },
  ERROR_CODE_18: {
    en: 'There was a problem updating the password. Please try again later.',
    zh: ''
  },
  ERROR_CODE_19: {
    en: 'Cannot update profile because the email address/phone number already exists',
    zh: ''
  },
  ERROR_CODE_20: {
    en: 'The email provided is already subscribed.',
    zh: ''
  },
  ERROR_CODE_21: {
    en: 'Your account has been locked due to too many incorrect login attempts.  Please try again after 20 minutes or reset your password.',
    zh: ''
  },
  // TODO: Use ff-constants
  ERROR_CODE_46: {
    en: 'User is not logged in.',
    zh: '用户未登录'
  },
  ERROR_CODE_51: {
    en: 'There was a problem registering new user. Please try again later.',
    zh: ''
  },
  ERROR_CODE_52: {
    en: 'There was a problem registering new user. Please try again later.',
    zh: ''
  },
  ERROR_CODE_53: {
    en: 'There was a problem subscribing to newsletter. Please try again.',
    zh: ''
  },
  ERROR_CODE_54: {
    en: 'There was a problem subscribing to newsletter. Please try again.',
    zh: ''
  },
  ERROR_CODE_55: {
    en: 'There was a problem subscribing to newsletter. Please try again.',
    zh: ''
  },
  ERROR_CODE_56: {
    en: 'There was a problem updating user profile. Please try again later.',
    zh: ''
  },
  ERROR_CODE_57: {
    en: 'There was a problem updating user profile. Please try again later.',
    zh: ''
  },
  ERROR_CODE_101: {
    en: 'Failed to connect to FFID /subscribe endpoint',
    zh: ''
  },
  ERROR_CODE_102: {
    en: 'Failed to connect to FFID /id endpoint',
    zh: ''
  },
  ERROR_CODE_103: {
    en: 'FFID resetPasswordFinish validation error',
    zh: ''
  },
  ERROR_CODE_104: {
    en: 'Reset password token already used or has expired',
    zh: ''
  },
  ERROR_CODE_105: {
    en: 'Password needs to have at least 8 characters containing at lease 1 number and 1 character',
    zh: ''
  },
  ERROR_CODE_106: {
    en: 'Reset password token must not be empty',
    zh: ''
  },
  ERROR_CODE_107: {
    en: 'FFID change password validation error',
    zh: ''
  },
  ERROR_CODE_108: {
    en: 'The new password cannot be the same as the current password',
    zh: ''
  },
  ERROR_CODE_109: {
    en: 'The old password you entered does not match the one on record',
    zh: ''
  },
  ERROR_CODE_110: {
    en: 'Your previous login token has expired. Please try to log in again',
    zh: ''
  },
  ERROR_CODE_150: {
    en: 'Something went wrong. Please try to log in again',
    zh: ''
  },
  ERROR_CODE_151: {
    en: 'There was a problem sending out email. Please try again later.',
    zh: ''
  },
  ERROR_CODE_152: {
    en: 'There was a problem sending out email. Please try again later.',
    zh: ''
  },
  ERROR_CODE_153: {
    en: 'There was a problem sending out email. Please try again later.',
    zh: ''
  },
  ERROR_CODE_154: {
    en: 'There was a problem sending out email. Please try again later.',
    zh: ''
  },
  ERROR_CODE_202: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_203: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_204: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_206: {
    en: 'Token expired. Please log in again.',
    zh: ''
  },
  ERROR_CODE_207: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_208: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_209: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_210: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_211: {
    en: 'There was a problem updating order status. Please try again later.',
    zh: ''
  },
  ERROR_CODE_212: {
    en: 'Token expired. Please log in again.',
    zh: ''
  },
  ERROR_CODE_213: {
    en: 'Permission denied.',
    zh: ''
  },
  ERROR_CODE_251: {
    en: 'Payment service is temporarily unavailable. Please try again later.',
    zh: ''
  },
  ERROR_CODE_252: {
    en: 'Payment failed. Please try again later.',
    zh: ''
  },
  ERROR_CODE_253: {
    en: 'Payment details cannot be retrieved. Please try again later.',
    zh: ''
  },
  ERROR_SERVER: {
    en: 'Server Error. Please try again later.',
    zh: ''
  },
  ERROR_CONTACT_SALES: {
    en: 'We are unable to finish your request, please try again. If problem persists, contact sales@ff.com or 1.800.228.7702 for immediate support.',
    zh: ''
  },
};
